import { useIsMapOwner } from '~map-preview/hooks/useIsMapOwner'

const owner = (Component) => (props) => {
  const isOwner = useIsMapOwner()
  if (!isOwner) return null
  return <Component {...props} />
}

export { owner }
